import { render, staticRenderFns } from "./CreateChannelButton.vue?vue&type=template&id=3cc7309b&"
import script from "./CreateChannelButton.vue?vue&type=script&lang=js&"
export * from "./CreateChannelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports